<div class="login-container new-login-container">
	<div class="top-bar-left" *ngIf="enableCustomKeyboard">
		<div class="row align-content-center m-w-300 t4">
			<img class="location-image" src="../../../assets/img/location_on.svg">
			<div class="location-container">

				<div class="row-md-12 text-center text-muted institution-name">{{ institutionName }}</div>
				<div class="row-md-12 text-center text-muted stock-location-name">{{ stockLocationName }}</div>
				<div *ngIf="deviceService.isTheaterDevice()"
					class="row-md-12 text-center text-muted stock-location-name">{{ deviceType }}
				</div>
				
			</div>
		</div>
	</div>
	<div class="wifi-icon">
		<mat-icon svgIcon="wifi-on" [hidden]="!isConnected"></mat-icon>
		<mat-icon svgIcon="wifi-off" [hidden]="isConnected"></mat-icon>
	</div>
	<section class="row justify-content-center login" [ngClass]="{
		'conditional-class': enableCustomKeyboard && !displayPinScreen
	 }">

		<div *ngIf="pinActive !== undefined" class="login-div is-mobile">
			<div class="logo logo-top" *ngIf="enableCustomKeyboard || !isMobile" (dblclick)="reload()">
				<img [class.clinix-logo]="isClinixLogo()" [class.lenmed-logo]="!isClinixLogo()" src="{{ logo }}">
			</div>

			<div class="row mb-4">
				<div class="col" *ngIf="!this.kronosLogin">
					<div *ngIf="!enableCustomKeyboard" class="btn-group">
						<button type="button" class="btn btn-outline-secondary" [ngClass]="{active: !pinActive}"
							(click)="displayUsernamelogin()">
							PASSWORD
						</button>
						<button type="button" class="btn btn-outline-secondary" [ngClass]="{active: pinActive}"
							(click)="displayPinlogin();">
							PIN
						</button>
					</div>
				</div>
			</div>

		  <app-login *ngIf="this.kronosLogin"
				(createPin)="createUserPin($event)"></app-login>
			<app-login *ngIf="!pinActive && !displayPinScreen && !enableCustomKeyboard && !this.kronosLogin"
				(createPin)="createUserPin($event)"></app-login>
			<app-pin-login *ngIf="enableCustomKeyboard && !displayPinScreen && !this.kronosLogin" [pinActive]="pinActive"
				(showLogIn)="displayUsernamelogin()" (createPin)="createUserPin($event)"></app-pin-login>
			<app-desktop-pin-login
				*ngIf="!enableCustomKeyboard && pinActive && !displayPinScreen"></app-desktop-pin-login>
			<app-pin *ngIf="displayPinScreen" [userName]="userName" (showLogIn)="reloadUsernamelogin()"></app-pin>

			<div class="logo logo-top" *ngIf="!enableCustomKeyboard && isMobile" (dblclick)="reload()">
				<img [class.clinix-logo]="isClinixLogo()" [class.lenmed-logo]="!isClinixLogo()" src="{{ logo }}">
			</div>
			<div *ngIf="!enableCustomKeyboard" class="device-info">
				<div class="row align-content-center m-w-300 t4">
					<div class="col-md-12 text-center text-muted">{{ device?.institutionName }}</div>
				</div>
				<div class="row align-content-center m-w-300 t4">
					<div class="col-md-12 text-center text-muted">{{ device?.stockLocationName }}</div>
				</div>
				<div *ngIf="deviceService.isTheaterDevice()" class="row align-content-center m-w-300 t4">
					<div class="col-md-12 text-center text-muted">{{ deviceType }}</div>
				</div>
				<div class="row align-content-center m-w-300 t4">
					<div class="col-md-12 text-center text-muted">{{ version }}</div>
				</div>
			</div>
			<div *ngIf="!this.kronosLogin">
				<div *ngIf="pinActive" class="forgot-pin">Forgot your PIN? <u class="pointer"
						(click)="displayUsernamelogin()">Use Password</u></div>
			</div>

			<br>
			<div *ngIf="!this.kronosLogin">
				<div *ngIf="!pinActive && !displayPinScreen" class="forgot-pin">Have a PIN? <u class="pointer"
						(click)="displayPinlogin()">Use it to log in.</u></div>
			</div>

		</div>
	</section>
</div>